__turbopack_context__.v({
  "card": "B2bOfferingCard-module-scss-module__kw-YMG__card",
  "description": "B2bOfferingCard-module-scss-module__kw-YMG__description",
  "list": "B2bOfferingCard-module-scss-module__kw-YMG__list",
});
